module.exports = __webpack_public_path__ + "media/images/landing/icon-report-04324b58bcfaf6b91d59eb8d53bfeddc.svg";